export default __webpack_public_path__ + "static/xy-histogram-with-mean-aggregation-22320a6e275fa5f4588284a6265b9cec.png";